import { render, staticRenderFns } from "./LmFormBuilderPreview.vue?vue&type=template&id=089b0dc8&"
import script from "./LmFormBuilderPreview.vue?vue&type=script&lang=js&"
export * from "./LmFormBuilderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports